import { render, staticRenderFns } from "./coupon-price.mpx?vue&type=template&id=6bd2d8e5&scoped=true&isComponent&outputPath=components%2Fcoupon-price6e4ad8c6%2Findex"
import script from "./coupon-price.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcoupon-price6e4ad8c6%2Findex"
export * from "./coupon-price.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcoupon-price6e4ad8c6%2Findex"
import style0 from "./coupon-price.mpx?vue&type=style&index=0&id=6bd2d8e5&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m6e4ad8c6%22%7D&isComponent&outputPath=components%2Fcoupon-price6e4ad8c6%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2d8e5",
  null
  
)

export default component.exports